"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setCachedNotificationHashlist = exports.getLoggedStatus = exports.setCachedNotifications = exports.getCachedNotifications = exports.getCookie = exports.decodeURIObject = void 0;
const constants_1 = require("../constants");
const utils_secure_user_secure_storage_1 = __importDefault(require("@gcloud-npm/utils.secure.user-secure-storage"));
const currentEnv = process.env.NEXT_PUBLIC_ENV_NAME;
const secureUserStorage = new utils_secure_user_secure_storage_1.default();
function decodeURIObject(obj) {
    let res = null;
    try {
        res = JSON.parse(decodeURIObject(obj));
    }
    catch (e) {
        console.log("Failed to decode URI Object");
    }
    return res;
}
exports.decodeURIObject = decodeURIObject;
function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
exports.getCookie = getCookie;
function getCachedNotifications({ userId }) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        const persistedInfo = yield secureUserStorage.getUserStore({ id: userId });
        let cachedNotifications = (_a = persistedInfo === null || persistedInfo === void 0 ? void 0 : persistedInfo.notifications) === null || _a === void 0 ? void 0 : _a.notifications;
        let cachedUnreadNotifications = ((_b = persistedInfo === null || persistedInfo === void 0 ? void 0 : persistedInfo.notifications) === null || _b === void 0 ? void 0 : _b.unreadNotifications) || [];
        return { cachedNotifications, cachedUnreadNotifications };
    });
}
exports.getCachedNotifications = getCachedNotifications;
function setCachedNotifications({ userId, notifications, unreadNotifications, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const prev = (yield secureUserStorage.getUserStore({ id: userId })) || {};
        prev.notifications = Object.assign(Object.assign({}, ((prev === null || prev === void 0 ? void 0 : prev.notifications) || {})), { notifications: notifications, unreadNotifications });
        yield secureUserStorage.setUserStore({
            id: userId,
            data: prev,
        });
    });
}
exports.setCachedNotifications = setCachedNotifications;
function getLoggedStatus() {
    if (getCookie("seth-session-logged") || currentEnv === "local") {
        return constants_1.LOGGED_STATUS.LOGGED;
    }
    if (getCookie("seth-session-softlogged")) {
        return constants_1.LOGGED_STATUS.SOFTLOGGED;
    }
    return constants_1.LOGGED_STATUS.PUBLIC;
}
exports.getLoggedStatus = getLoggedStatus;
function setCachedNotificationHashlist({}) { }
exports.setCachedNotificationHashlist = setCachedNotificationHashlist;
//# sourceMappingURL=storage.js.map